import { PixiAppHelper } from "score_render";

export let pixiAppHelper:PixiAppHelper;

export function setMainPixiApp(setPixiAppHelper:PixiAppHelper):void {
	if (pixiAppHelper == null){
		pixiAppHelper = setPixiAppHelper;
	}
}